// Nuevo
import { useContext, useEffect, useState } from "react";
import {
  DatosReporte2DTO,
  FiltroRepPlano2DTO,
} from "../../models/controlls.model";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable, {
  MUIDataTableColumn,
  MUIDataTableColumnDef,
  MUIDataTableFilterOptions,
  MUIDataTableOptions,
  TableFilterList,
} from "mui-datatables";
import {
  Button,
  ButtonGroup,
  Chip,
  Fade,
  IconButton,
  Input,
  Snackbar,
  TextField,
  Tooltip,
} from "@material-ui/core";

import axios from "axios";
import { appSettings } from "../endpoints";
import PieContext from "../../PieContext";
import CalendarC from "./CalendarC";
import AutoCompleteLocalC from "./AutoComleteLocalC";
import icoExcelDorado from "../../assets/images/icoExcelDorado.svg";
import iconSearch from "../../assets/images/search_icon.png";
import {
  NavigateBefore,
  NavigateNext,
  Search,
  Close,
} from "@material-ui/icons";
import React from "react";

export default function ReporteLocal(props: reporteLocalProps) {
  //#region Const
  const [isInit, setIsInit] = useState<boolean>(true);
  const {
    actualizaDataEstadistica,
    dataEstadistica,
    actualizaDataEstadisticaFiltered,
    dataEstadisticaFiltered,
    actualizaDataEstadisticaPaged,
    dataEstadisticaPaged,
    dataEstatica,
  } = useContext(PieContext);
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState<{ open: boolean }>({ open: false });
  const [defineCol, setDefineCol] = useState<MUIDataTableColumnDef[]>([]);
  const [heightFiltro, setHeightFiltro] = useState(0);
  const [download, setDownload] = useState("");
  const [API_URL, setApiURL] = useState("");
  const [API_Service, setApiService] = useState("");
  const [paginaActual, setPaginaActual] = useState(0);
  const [filasPorPag, setFilasPorPag] = useState(20);
  const [filasTotal, setFilasTotal] = useState(0);
  const [withSentence, setWithSentence] = useState(false);
  const [dataOriginal, setDataOriginal] = useState<any[]>([]);
  const [loadingDatas, setLoadingDatas] = useState<boolean>(true);
  const [filtersSelected, setFiltersSelected] = useState<any[]>([]);
  const [resetDataFiltered, setResetDataFiltered] = useState<boolean>(false);
  const [cleanFilters, setCleanFilters] = useState<boolean>(false);
  const [showInputSearch, setShowInputSearch] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const camposNoAgrupadores: string[] = [
    "Fecha de recepción",
    "Fecha de resolución",
    "Fecha turno",
    "Fecha y hora recepción",
    "Expediente",
    "Sentencias",
    "Consecutivo",
    "Acumulado", // hacer esto como un autocomplete normal
    "Expediente",
    "Sentido general de medios",
  ];
  const removeAccents = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const entityNames: any = {
    "Aguascalientes                                                                                      ":
      "Aguascalientes",
    "Puebla                                                                                              ":
      "Puebla",
    "Durango                                                                                             ":
      "Durango",
    "Federal                                                                                             ":
      "Federal",
    "Hidalgo                                                                                             ":
      "Hidalgo",
    "Baja California Sur                                                                                 ":
      "Baja California Sur",
    "Baja California                                                                                     ":
      "Baja California",
    "Tamaulipas                                                                                          ":
      "Tamaulipas",
    "Tabasco                                                                                             ":
      "Tabasco",
    "Ciudad de México                                                                                    ":
      "Ciudad de México",
    "Nayarit                                                                                             ":
      "Nayarit",
    "Oaxaca                                                                                              ":
      "Oaxaca",
    "Chihuahua                                                                                           ":
      "Chihuahua",
    "Quintana Roo                                                                                        ":
      "Quintana Roo",
    "Campeche                                                                                            ":
      "Campeche",
    "Chiapas                                                                                             ":
      "Chiapas",
    "Coahuila                                                                                            ":
      "Coahuila",
    "Morelos                                                                                             ":
      "Morelos",
    "Veracruz                                                                                            ":
      "Veracruz",
    "Michoacán                                                                                           ":
      "Michoacán",
    "Jalisco                                                                                             ":
      "Jalisco",
    "Querétaro                                                                                           ":
      "Querétaro",
    "Colima                                                                                              ":
      "Colima",
    "Guerrero                                                                                            ":
      "Guerrero",
    "Guanajuato                                                                                          ":
      "Guanajuato",
    "Yucatán                                                                                             ":
      "Yucatán",
    "Estado de México                                                                                    ":
      "Estado de México",
    "Tlaxcala                                                                                            ":
      "Tlaxcala",
    "Sonora                                                                                              ":
      "Sonora",
    "San Luis Potosí                                                                                     ":
      "San Luis Potosí",
    "Sinaloa                                                                                             ":
      "Sinaloa",
    "Zacatecas                                                                                           ":
      "Zacatecas",    
    "Nuevo León                                                                                          ":
      "Nuevo León"
  };

  const options: MUIDataTableOptions = {
    serverSide: true,
    fixedHeader: true,
    fixedSelectColumn: true,
    selectableRows: "none",
    pagination: true,
    count: filasTotal,
    page: paginaActual,
    rowsPerPage: filasPorPag,
    rowsPerPageOptions: [20, 50, 100, 250],
    //tableBodyHeight: `${props.alto - 10}px`,
    //tableBodyHeight: `550px`,
    print: false,
    search: false,
    textLabels: {
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Total de registros por página",
        displayRows: "de",
      },
      filter: {
        reset: "Limpiar",
        title: "Filtros",
      },
      toolbar: {
        downloadCsv: "Descarga CSV",
        filterTable: "Filtros de tabla",
        //search: "Búsqueda",
        viewColumns: "Mostrar/Ocultar",
      },
      body: {
        noMatch: "No se encontraron resultados",
        toolTip: "Ordenar",
      },
      viewColumns: {
        title: "Ver columnas",
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      setLoader(true);
      let columnas: string[] = columns.reduce((acc: string[], cvv: any) => {
        acc.push(cvv.name);
        return acc;
      }, []);
      let datosCSV: any[] = [];
      dataOriginal.forEach((obj: any, idx: number) => {
        let body: string[] = [];
        for (let prop in obj) {
          if (columnas.indexOf(prop) !== -1) body.push(obj[prop]);
        }
        datosCSV.push({ index: idx, data: body });
      });
      setDownload(`${buildHead(columns)}${buildBody(datosCSV)}`.trim());
      setLoader(false);

      return false;
    },
    onChangePage(currentPage) {
      setPaginaActual(currentPage);
    },
    onChangeRowsPerPage(numberOfRows) {
      setFilasPorPag(numberOfRows);
    },
    customToolbar: () => {
      return (
        <>
          <Tooltip title={"Descarga excel"}>
            <IconButton onClick={btnExcel(dataOriginal, "Estadística")}>
              <img
                style={{ width: "30px", height: "30px" }}
                src={icoExcelDorado}
                alt=""
              />
            </IconButton>
          </Tooltip>
          {!showInputSearch ? (
            <Tooltip title={"Búsqueda por palabras"}>
              <IconButton onClick={() => setShowInputSearch(true)}>
                <img
                  style={{ width: "30px", height: "30px" }}
                  src={iconSearch}
                  alt=""
                />
              </IconButton>
            </Tooltip>
          ) : (
            <TextField
              type="text"
              placeholder="Palabra a buscar"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              InputProps={{
                endAdornment: (
                  <React.Fragment>
                    <Tooltip title={"Buscar"}>
                      <IconButton
                        id={`ico-buscar`}
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={() => {
                          searchByText();
                        }}
                      >
                        <Search />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={"Limpiar"}>
                      <IconButton
                        id={`ico-buscar`}
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={() => {
                          if (searchText.length === 0) {
                            setShowInputSearch(false);
                            return;
                          }

                          setSearchText("");
                          actualizaDataEstadisticaFiltered([
                            ...dataEstadistica,
                          ]);
                        }}
                      >
                        <Close />
                      </IconButton>
                    </Tooltip>
                  </React.Fragment>
                ),
              }}
              style={{
                width: "300px",
                marginLeft: "5px",
              }}
            />

            // <TextField
            //   placeholder="Palabra a buscar"
            //   style={{ width: "300px" }}
            //   inputProps={{
            //     endAdornment: (
            //       <React.Fragment>
            //         <>
            //           <Tooltip title="Buscar">
            //             <IconButton
            //           aria-label="more"
            //           aria-controls="long-menu"
            //           aria-haspopup="true">
            //               <Search />
            //             </IconButton>
            //           </Tooltip>
            //         </>
            //       </React.Fragment>
            //     ),
            //   }}
            // ></TextField>
          )}
        </>
      );
    },
    customFooter(
      rowCount,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage,
      textLabels
    ) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "0px 8px",
            height: "52px",
            width: "100%",
            fontSize: "14px",
            flexWrap: "wrap-reverse",
          }}
        >
          {`Filas totales: `}
          <strong>{rowCount}</strong>&nbsp;{`Registros por página`} &nbsp;
          <select
            style={{
              maxWidth: "50px",
            }}
            onChange={(e) => {
              setLoadingDatas(true);
              setFilasPorPag(parseInt(e.target.value));
            }}
            disabled={loadingDatas}
          >
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="250">250</option>
          </select>
          &nbsp; Ir a página{" "}
          <select
            style={{
              maxWidth: "50px",
            }}
            onChange={(e) => {
              setLoadingDatas(true);
              setPaginaActual(parseInt(e.target.value));
            }}
            value={paginaActual}
            disabled={loadingDatas}
          >
            {[...Array(Math.ceil(rowCount / filasPorPag))].map((item, idx) => (
              <option value={idx}>{idx + 1}</option>
            ))}
          </select>
          &nbsp;
          {` Página ${paginaActual + 1} de ${Math.ceil(
            rowCount / filasPorPag
          )} `}
          <ButtonGroup variant="text" size="small">
            {/* <Tooltip title="Primera" placement="top">
          <Button
            onClick={() => setPaginaActual(0)}
            disabled={paginaActual === 0 || (Math.ceil(rowCount/filasPorPag)-1) === 0}
          ><FirstPage/></Button></Tooltip> */}

            <Tooltip title="Anterior" placement="top">
              <Button
                disabled={
                  paginaActual === 0 ||
                  Math.ceil(rowCount / filasPorPag) - 1 === 0 ||
                  loadingDatas
                }
                onClick={() => {
                  setLoadingDatas(true);
                  setPaginaActual(paginaActual - 1);
                }}
              >
                <NavigateBefore />
              </Button>
            </Tooltip>

            <Tooltip title="Siguiente" placement="top">
              <Button
                disabled={
                  paginaActual === Math.ceil(rowCount / filasPorPag) - 1 ||
                  Math.ceil(rowCount / filasPorPag) === 0 ||
                  loadingDatas
                }
                onClick={() => {
                  setLoadingDatas(true);
                  setPaginaActual(paginaActual + 1);
                }}
              >
                <NavigateNext />
              </Button>
            </Tooltip>

            {/* <Tooltip title="Última" placement="top">
              <Button
                disabled={
                  paginaActual === Math.ceil(filasTotal / filasPorPag) - 1 ||
                  Math.ceil(filasTotal / filasPorPag) === 0
                }
                onClick={() =>
                  setPaginaActual(Math.ceil(filasTotal / filasPorPag) - 1)
                }
              >
                <LastPage />
              </Button>
            </Tooltip> */}
          </ButtonGroup>
        </div>
      );
    },
  };

  //#endregion Const

  //#region Effects
  useEffect(() => {
    appSettings.then((res) => {
      setApiURL(res.API_URL);
      setApiService(res.EXPEDIENTES_CONSULTA);
    });
  }, []);

  useEffect(() => {
    if ([API_URL, API_Service].includes("")) return;

    RecuperaDatos();
    dameHeightEncabezado();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [API_URL, API_Service]);

  useEffect(() => {
    if (download.length > 0) {
      // let textEncoder = new TextEncoder();
      //let txt = textEncoder.encode(download)
      let blob = new Blob(["\ufeff", download], {
        type: "text/csv;charset=windows-1252;",
      });
      let a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob);
      a.download = "DatosEstadisticos.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setDownload("");
    }
  }, [download]);

  //----------------------------------------------
  useEffect(() => {
    if (isInit) return;

    DefineColumnas();
  }, [dataEstadistica]);

  useEffect(() => {
    if (!resetDataFiltered) return;

    setPaginaActual(0);
    setResetDataFiltered(false);
  }, [resetDataFiltered]);

  useEffect(() => {
    if (isInit) return;

    setPaginaActual(-1);
    setResetDataFiltered(true);
  }, [dataEstadisticaFiltered]);

  useEffect(() => {
    if (isInit || paginaActual === -1) return;

    setLoadingDatas(true);
    paginateData();
  }, [paginaActual, filasPorPag]);

  useEffect(() => {
    if (isInit) return;

    applyFilters();
  }, [filtersSelected]);

  useEffect(() => {
    console.log(dataEstadisticaPaged);
  }, [dataEstadisticaPaged]);

  useEffect(() => {
    if (!cleanFilters) return;

    //filtersSelected.forEach(i => i = []);
    actualizaDataEstadisticaFiltered([...dataEstadistica]);
    setCleanFilters(false);
  }, [cleanFilters]);
  //----------------------------------------------
  //#endregion Effects

  //#region LocalFunctions
  function getColumnas(byFilters: boolean = false): string[] {
    let campos: string[] = [];
    let haveSentences: boolean = false;
    for (let campo in props.camposReporte) {
      if (props.camposReporte[campo]["nombreColumna"] === "BuscarSentencias") {
        haveSentences = true;
        continue;
      }

      let objCampo = props.camposReporte[campo];
      if (objCampo["filtro"] === false) {
        campos.push(campo);
      }
    }
    if (haveSentences) {
      campos.push("Observaciones");
      campos.push("Sentencias");
    }

    return campos;
  }

  function DefineColumnas() {
    let columnsMUI: MUIDataTableColumnDef[] = getColumnas().reduce(
      (acc: MUIDataTableColumnDef[], cval: string, idx: number) => {
        let optionsCols: MUIDataTableFilterOptions | undefined =
          cval.split("-")[0].indexOf("Fecha") !== -1
            ? {
                names: [],
                logic(prop: string, filterValue: any[]) {
                  if (filterValue.length === 2 && filterValue[0] !== "") {
                    let fecha1 = new Date(filterValue[0]);
                    let fecha2 = new Date(filterValue[1]);
                    let fechaP = new Date(prop);

                    return !(fecha1 <= fechaP && fechaP <= fecha2);
                  }
                  return false;
                },
                display: (
                  filterList: string[][],
                  onChange,
                  index: number,
                  column: MUIDataTableColumn
                ) => (
                  <CalendarC
                    key={`calF-${column.name}-${idx}`}
                    id={cval}
                    años={props.años}
                    filtro={false}
                    filtros={{}}
                    opciones={false}
                    onlyMonth={false}
                    values={
                      filterList[index].length === 0
                        ? undefined
                        : filterList[index]
                    }
                    eliminaInput={(idCampo: string, filtroInput: boolean) => {}}
                    guardaSeleccion={(
                      campo: string,
                      filtro: FiltroRepPlano2DTO
                    ) => {
                      if (filtro.valor[0] === "") return;

                      filterList[index] = filtro.valor;
                      onChange(filterList[index], index, column);
                      buildFilters(filterList);
                    }}
                  />
                ),
              }
            : !["Observaciones", "Sentencias"].includes(cval)
            ? {
                logic(prop: string, filterValue: any[]) {
                  if (filterValue.length) return !filterValue.includes(prop);

                  return false;
                },
                display: (
                  filterList: string[][],
                  onChange,
                  index: number,
                  column: MUIDataTableColumn
                ) => (
                  <AutoCompleteLocalC
                    key={`acF-${column.name}-${index}`}
                    id={cval}
                    filtro={false}
                    filtros={{}}
                    opciones={false}
                    values={filterList[index]}
                    datos={generaDistinctCampo(column.name)}
                    eliminaInput={(idCampo: string, filtroInput: boolean) => {}}
                    guardaSeleccion={(
                      campo: string,
                      filtro: FiltroRepPlano2DTO
                    ) => {
                      filterList[index] = filtro.valor;
                      onChange(filterList[index], index, column);
                      buildFilters(filterList);
                    }}
                  />
                ),
              }
            : {};

        let columna: MUIDataTableColumnDef = {
          name: cval,
          label: cval,
          options: {
            filter: true,
            filterType: "custom",
            // sort: false,
            // hint: "Ordenar",
            // customBodyRenderLite: (dataIndex) => {
            //   let val = datosfilas[dataIndex];
            //   return val[cval];
            // },
            customFilterListOptions: {
              render: (v: any) => {
                return v[1] ? [`${v[0]} - ${v[1]}`] : [`${v[0]}`];
              },
              update: (
                filterList: string[][],
                filterPos: number,
                index: number
              ) => {
                filterList[index] = [];
                return filterList;
              },
            },
            filterOptions: optionsCols,
          },
        };

        acc.push(columna);
        return acc;
      },
      []
    );
    setDefineCol(columnsMUI);
    setLoadingDatas(false);
  }

  function dameHeightEncabezado() {
    let alto = document.getElementById("filtroRep")?.offsetHeight;
    setHeightFiltro(alto ? alto + 10 : 0);
  }

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 0px 0px 5px",
          },
        },
        MUIDataTableBodyCell: {
          root: {
            maxHeight: "500px",
            overflowX: "auto",
          },
        },
        MUIDataTableHeadCell: {
          root: {
            backgroundColor: "#24135f !important",
            borderBottom: "1px solid #000",
            borderRight: "1px solid #B0B0AA",
            borderLeft: "1px solid #B0B0AA",
            borderTop: "1px solid #B0B0AA",
          },
          data: {
            color: "#FFFF !important",
            fontWeight: "bold",
          },
        },
        MUIDataTableBodyRow: {
          root: {
            backgroundColor: "#e3e1eb",
          },
        },
        MUIDataTablePagination: {
          root: {
            backgroundColor: "#c2b5f1",
            color: "#000000",
          },
        },
        MuiIconButton: {
          root: {
            color: "#b1a252",
          },
        },
      },
    });

  const handleCloseSnack = () => setState({ open: false });

  function generaDistinctCampo(campo: string): any[] {
    if (
      [
        "Consecutivo",
        "Expediente",
        "Acumulado",
        "Sentido general de medios",
      ].includes(campo)
    )
      return [];

    let noAgrupa = camposNoAgrupadores.includes(campo);
    if (noAgrupa) {
      let filtered = dataEstadistica.reduce((acc: any[], cval: any) => {
        acc.push({ value: cval[campo], texto: cval[campo] });
        return acc;
      }, []);

      return [...new Set(filtered)];
    } else {
      let distinctCampo: any[] = [];
      dataEstadistica.reduce((acc: string[], cval: any) => {
        if (!acc.includes(cval[campo])) {
          acc.push(cval[campo]);
          distinctCampo.push({ value: cval[campo], texto: cval[campo] });
        }
        return acc;
      }, []);

      let datas = [...new Set(distinctCampo)];
      if (campo === "Entidad")
        datas = datas.sort((a, b) => {
          if (a.value < b.value) {
            return -1;
          }
          if (a.value > b.value) {
            return 1;
          }
          return 0;
        });
      return datas;
    }
  }

  const CustomChip = (propsChip: any) => {
    const { label, onDelete, columnNames, index } = propsChip;
    return (
      <Chip
        variant="outlined"
        color="primary"
        label={`${columnNames[index].name}: ${label}`}
        onDelete={() => filterWithChips(propsChip)}
      />
    );
  };

  const CustomFilterList = (propsFilter: any) => {
    return <TableFilterList {...propsFilter} ItemComponent={CustomChip} />;
  };

  const buildYears = (years: string[]) => {
    let dif = parseInt(years[1]) - parseInt(years[0]);
    let yearsComplete: string[] = [];
    let firstYear: number;

    if (dif === 0) return [years[1]];
    else if (dif === 1) return years;
    else {
      for (let i = 0; i <= dif; i++) {
        firstYear = parseInt(years[0]) + i;

        yearsComplete.push(`${firstYear}`);
      }
      return yearsComplete;
    }
  };

  const filterWithSentencias = (
    reportePlano: any[],
    datosSentencias: any[]
  ) => {
    let filtered: any[] = [];
    let filteredOriginal: any[] = [];
    datosSentencias.forEach((e) => {
      let datas = reportePlano.filter(
        (i) => {
          return i["Año"] === e["anho"][0] &&
          i["Medio"].trim() === e["medio"][0].trim() &&
          i["Sala"].trim() === e["sala"][0].trim() &&
          i["Consecutivo"] === e["consecutivo"][0]
        }
      );

      if (datas.length === 0) return;
      datas.forEach((data) => {
        let aux = { ...data };

        let linkSentencia = `https://www.te.gob.mx/sentenciasHTML/convertir/expediente/${e.sala[0]}-${e.medio[0]}-${e.consecutivo[0]}-${e.anho[0]}`;
        if (e.obs[0].trim().length > 0) linkSentencia += `-${e.obs[0]}`;

        aux["Sentencias"] = linkSentencia;
        aux["Observaciones"] = e.obs[0];
        data["Sentencias"] = (
          <a href={linkSentencia} target="_blank">
            Ir a sentencia
          </a>
        );
        data["Observaciones"] = e.obs[0];

        filtered.push({ ...data });
        filteredOriginal.push({ ...aux });
      });
    });
    setDataOriginal(filteredOriginal);

    //return [...new Set(filtered)];
    return filtered;
  };

  function searchByText(): void {
    if (isInit) return;

    if (searchText === "") {
      actualizaDataEstadisticaFiltered([...dataEstadistica]);
      return;
    }

    applyFilters();
    // let datas: any[] = filterByText([...dataEstadistica]);
    // actualizaDataEstadisticaFiltered(datas);
  }

  function searchMatches(record: any): any {
    let recordWithMarks: any = {};
    Object.keys(record).forEach((key) => {      
      if (record[key] === undefined) return;
      if (
        !record[key].toString().toLowerCase().includes(searchText.toLowerCase())
      ) {
        recordWithMarks[key] = record[key];
        return;
      }

      let newText = markText(record[key]);
      recordWithMarks[key] = (
        <p>
          {newText[0]}
          <mark>{newText[1]}</mark>
          {newText[2]}
        </p>
      );
    });
    return recordWithMarks;
    // let datos = [...document.getElementsByTagName("td")];

    // datos.forEach((dato) => {
    //   if (searchText.length === 0 || dato.innerHTML.includes("<mark>")) {
    //     let regex = new RegExp(`<mark>`, "gi");
    //     let regex2 = new RegExp(`</mark>`, "gi");
    //     let inner = dato.innerHTML;

    //     let nuevoTxt = inner.replace(regex, "");
    //     nuevoTxt = nuevoTxt.replace(regex2, "");
    //     dato.innerHTML = nuevoTxt;
    //   }

    //   if (
    //     searchText.length === 0 ||
    //     !dato.innerText.toLowerCase().includes(searchText.toLowerCase())
    //   )
    //     return;

    //   let pos = dato.innerText
    //     .toLowerCase()
    //     .indexOf(searchText.toLocaleLowerCase());
    //   let txtRmp = dato.innerText.substring(pos, pos + searchText.length);
    //   let regex = new RegExp(`${searchText}`, "gi");
    //   let nuevoTxt = dato.innerHTML.replace(regex, `<mark>${txtRmp}</mark>`);
    //   dato.innerHTML = nuevoTxt;
    // });
  }

  function markText(value: string): string[] {
    let pos = value.toLowerCase().indexOf(searchText.toLocaleLowerCase());
    let firstText = value.substring(0, pos);
    let textToMark = value.substring(pos, pos + searchText.length);
    let lastText = value.substring(pos + searchText.length, value.length);
    return [firstText, textToMark, lastText];
  }

  //#endregion LocalFunctions

  //#region Services
  async function RecuperaDatos() {
    if (!props.recuperaDatos) return;

    actualizaDataEstadistica([]);
    actualizaDataEstadisticaFiltered([]);
    actualizaDataEstadisticaPaged([]);
    setLoader(true);
    let campos: FiltroRepPlano2DTO[] = [];

    for (let obj in props.camposReporte) {
      if (props.camposReporte[obj]["nombreColumna"] === "BuscarSentencias")
        continue;

      if (props.camposReporte[obj].valor[0] === "")
        props.camposReporte[obj].valor = [];

      if (
        props.camposReporte[obj].campo === "Sala" &&
        props.camposReporte[obj].valor.includes("SCM")
      )
        props.camposReporte[obj].valor.push("SDF");

      if (
        obj.includes("Año") &&
        ![
          "Año del proceso electoral",
          "Año de recepción",
          "Año de resolución",
        ].includes(obj)
      )
        props.camposReporte[obj].operador = "";

      campos.push(props.camposReporte[obj]);
    }

    let resDatosSentencias: any;

    let exist = false;
    for (const [key, value] of Object.entries(props.camposReporte)) {
      exist = props.camposReporte[key]["nombreColumna"] === "BuscarSentencias";
      if (exist) break;
    }

    if (exist)
      resDatosSentencias = await handleBuscarEnSentencias(props.camposReporte);
    
    console.log(resDatosSentencias)

    if (!campos.find((i) => i.campo === "Año"))
      campos.push({
        campo: "Año",
        valor: [props.años[0].toString(), props.años[1].toString()],
        operador: "",
        filtro: true,
        nombreColumna: "Anio",
      });
    let camposQuery: any[] = [];
    let camposDataEstatica: any[] = [];
    let searchInQuery: boolean = false;
    let searchInDataStatic: boolean = false;
    let filterSelection: any = {
      "igual a": filterEqual,
      contiene: filterContains,
      diferente: filterDifferent,
      betweenYears: filterBetweenYears,
      betweenDates: filterBetweenDates,
    };

    campos.forEach((element) => {
      let filterQuery: any = {};
      let filterDataStatica: any = {};

      if (element.campo === "Año") {
        if (parseInt(element.valor[0]) < 2018) {
          filterDataStatica = { ...element };
          searchInDataStatic = true;
          filterDataStatica.valor = [
            element.valor[0],
            parseInt(element.valor[1]) >= 2018 ? "2017" : element.valor[1],
          ];
        }
        if (parseInt(element.valor[1]) > 2017) {
          filterQuery = { ...element };
          searchInQuery = true;
          filterQuery.valor = [
            parseInt(element.valor[0]) <= 2017 ? "2018" : element.valor[0],
            element.valor[1],
          ];
        }
      } else {
        filterQuery = { ...element };
        filterDataStatica = { ...element };
      }

      if (Object.keys(filterQuery).length > 0) camposQuery.push(filterQuery);
      if (Object.keys(filterDataStatica).length > 0)
        camposDataEstatica.push(filterDataStatica);
    });

    let datosDTO: DatosReporte2DTO = {
      idEstadistica: 2,
      campos: camposQuery,
    };

    setDataOriginal([]);

    let resposeDataEstatica: any[] = [];
    let responseData: any[] = [];

    if (searchInDataStatic) {
      let firstFilter: boolean = true;
      for await (const filter of new Set(camposDataEstatica)) {
        if (filter.valor.length > 0 && filter.valor[0] !== "") {
          if (firstFilter && resposeDataEstatica.length === 0) {
            resposeDataEstatica = dataEstatica.filter((data) =>
              filter.operador === ""
                ? filter.campo.includes("Año")
                  ? filterSelection["betweenYears"](filter, data)
                  : filterSelection["igual a"](filter, data)
                : filter.campo.includes("Fecha")
                ? filterSelection["betweenDates"](filter, data)
                : filterSelection[filter.operador](filter, data)
            );
            firstFilter = false;
          } else {
            resposeDataEstatica = resposeDataEstatica.filter((data) =>
              filter.operador === ""
                ? filter.campo.includes("Año")
                  ? filterSelection["betweenYears"](filter, data)
                  : filterSelection["igual a"](filter, data)
                : filter.campo.includes("Fecha")
                ? filterSelection["betweenDates"](filter, data)
                : filterSelection[filter.operador](filter, data)
            );
          }
        }
      }
    }

    if (searchInQuery) {
      await axios
        .post(`${API_URL}/Estadistica/DatosReportePlanoLocal`, datosDTO)
        .then(async (response) => {
          let aux = [...response.data];
          for await (const data of aux) {
            data.Entidad = entityNames[data.Entidad];
            if (data["Usos y costumbres"] !== undefined)
              data["Usos y costumbres"] =
                data["Usos y costumbres"] === "-"
                  ? "Sin registro"
                  : data["Usos y costumbres"];
          }
          responseData = response.data;
        })
        .catch((err) => {
          setWithSentence(exist);
          setFilasTotal(0);
          setState({ open: true });
          setLoader(false);
        });
    }

    let dataResult = [...responseData, ...resposeDataEstatica];

    dataResult.forEach((data, index) => {
      data["Id"] = index + 1;
      if (data["Fecha de recepción"]) data["Fecha de recepción"] = data["Fecha de recepción"].substring(0, 10)
      if (data["Fecha de resolución"])  data["Fecha de resolución"] = data["Fecha de resolución"].substring(0, 10)
      if (data["Fecha turno"])  data["Fecha turno"] = data["Fecha turno"].substring(0, 10)
    });

    if ("Sentencia" in props.camposReporte)
      dataResult.forEach(
        (i: any) =>
          (i["Sentencia"] = (
            <a href={i["Sentencia"]} target="_blank">
              Ir a sentencia
            </a>
          ))
      );

    setIsInit(false);

    if (exist) {
      let filtered = [
        ...filterWithSentencias(dataResult, resDatosSentencias.data.resultados),
      ];
      actualizaDataEstadistica([...filtered]);
      actualizaDataEstadisticaFiltered([...filtered]);
    } else {
      actualizaDataEstadistica([...dataResult]);
      actualizaDataEstadisticaFiltered([...dataResult]);
    }

    setLoader(false);
  }

  function filterEqual(filter: any, data: any): boolean {
    return filter.valor.length === 1
      ? filter.valor[0] === data[filter.campo]
      : filter.valor.includes(data[filter.campo]);
  }

  function filterContains(filter: any, data: any): boolean {
    return filter.valor[0].includes(data[filter.campo]);
  }

  function filterDifferent(filter: any, data: any): boolean {
    return !filter.valor.includes(data[filter.campo]);
  }

  function filterBetweenYears(
    filter: any,
    data: any,
    localFilter: boolean = false
  ): boolean {
    if (localFilter) {
      return filter.valor.includes(data[filter.campo]);
    } else {
      return (
        parseInt(data[filter.campo]) >= parseInt(filter.valor[0]) &&
        parseInt(data[filter.campo]) <= parseInt(filter.valor[1])
      );
    }
  }

  function filterBetweenDates(filter: any, data: any): boolean {
    return (
      new Date(data[filter.campo].replace('-', '/')) >= new Date(filter.valor[0]) &&
      new Date(data[filter.campo].replace('-', '/')) <= new Date(filter.valor[1])
    );
  }

  function filterByText(currentDatas: any[]): any[] {
    let columns = getColumnas();
    let value: boolean;
    let datas: any[] = currentDatas.filter((data) => {
      value = false;

      for (let column of columns) {
        if (value) break;
        if (data[column] === undefined) continue;

        value = data[column]
          .toString()
          .toLowerCase()
          .includes(searchText?.toLowerCase());
      }

      return value;
    });

    return datas;
  }

  function paginateData(): void {
    let localDataEstadisticaFiltered = [...dataEstadisticaFiltered];
    let firstRecord: number =
      (paginaActual + 1) * filasPorPag - filasPorPag + 1;
    let lastRecord: number = (paginaActual + 1) * filasPorPag;
    let showData: any[] = [];
    for (let init = firstRecord; init <= lastRecord; init++) {
      let record = localDataEstadisticaFiltered[init - 1];
      if (record === undefined) continue;
      if (searchText.length > 0) record = { ...searchMatches(record) };

      showData.push({ ...record });
    }

    setDataOriginal(localDataEstadisticaFiltered);
    actualizaDataEstadisticaPaged([...showData]);
    setFilasTotal(localDataEstadisticaFiltered.length);
    setLoader(false);
    setLoadingDatas(false);
  }

  function buildFilters(filterList: any[]) {
    setFiltersSelected([...filterList]);
  }

  function applyFilters() {
    let countFilters = 0;
    filtersSelected.forEach((i) => {
      countFilters += i.length;
    });

    if (countFilters === 0 && searchText.length === 0) {
      actualizaDataEstadisticaFiltered([...dataEstadistica]);
      return;
    }

    let aux: any[] = [];

    let columns = getColumnas();

    let filterSelection: any = {
      "igual a": filterEqual,
      contiene: filterContains,
      diferente: filterDifferent,
      betweenYears: filterBetweenYears,
      betweenDates: filterBetweenDates,
    };

    let evalua: boolean;
    aux =
      countFilters > 0
        ? dataEstadistica.filter((data) => {
            for (let index = 0; index <= filtersSelected.length - 1; index++) {
              if (filtersSelected[index].length === 0) continue;

              evalua = columns[index].includes("Año")
                ? filterSelection["betweenYears"](
                    { valor: filtersSelected[index], campo: columns[index] },
                    data,
                    true
                  )
                : columns[index].includes("Fecha")
                ? filterSelection["betweenDates"](
                    { valor: filtersSelected[index], campo: columns[index] },
                    data
                  )
                : filterSelection["igual a"](
                    { valor: filtersSelected[index], campo: columns[index] },
                    data
                  );
              if (!evalua) break;
            }

            return evalua;
          })
        : [...dataEstadistica];

    if (searchText.length > 0) aux = filterByText(aux);

    actualizaDataEstadisticaFiltered([...aux]);
  }

  async function filterWithChips(propsChip: any) {
    const { onDelete, index } = propsChip;

    let localFiltersSelected = [...filtersSelected];

    localFiltersSelected[index] = [];

    onDelete();
    setFiltersSelected(localFiltersSelected);
  }

  async function handleBuscarEnSentencias(camposReporte: any) {
    let texto = "";
    for (const [key, value] of Object.entries(camposReporte)) {
      if (camposReporte[key]["nombreColumna"] === "BuscarSentencias") {
        texto = camposReporte[key]["valor"][0];
        break;
      }
    }
    texto = removeAccents(texto);
    let año = camposReporte["Año"];
    let añoRecepcion = camposReporte["Año de recepción"];
    let añoResolucion = camposReporte["Año de resolución"];

    //año [1996, 2022]
    //añoRecepcion [2005, 2007]
    //añoResolución [2009, 2016]

    let years = buildYears(camposReporte["Año"].valor);

    let filters = {
      texto: texto,
      sala: camposReporte["Sala"].valor.toString(),
      medio: camposReporte["Medio"].valor.toString(),
      anio: years.toString(),
      consecutivo: camposReporte["Consecutivo"].valor[0],
    };

    try {
      return await axios.post(API_Service, filters);
    } catch (error) {
      return [];
    }
  }

  //#endregion Services SM-JDC-898/2018

  //#region Events
  const btnExcel =
    (datos: any, nombre: string) => (event: React.MouseEvent) => {
      props.generaExcel(datos, nombre);
    };
  //#endregion
  return (
    <>
      {loader ? (
        <div className="loader"></div>
      ) : (
        <div>
          <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              title={"Expedientes"}
              data={dataEstadisticaPaged}
              columns={defineCol}
              options={options}
              components={{ TableFilterList: CustomFilterList }}
            />
          </MuiThemeProvider>
          <Snackbar
            open={state.open}
            onClose={handleCloseSnack}
            TransitionComponent={Fade}
            message={
              withSentence
                ? "La búsqueda no generó resultados."
                : "Error al recuperar datos del servidor."
            }
            key={"fade"}
          />
        </div>
      )}
    </>
  );
}

interface reporteLocalProps {
  camposReporte: any;
  alto: number;
  años: number[];
  recuperaDatos: boolean;
  generaExcel(csvData: any, fileName: string): void;
}

ReporteLocal.defaultProps = {
  recuperaDatos: true,
};
